import dialog from './dialog.js';

const makeHtml = function(args)
{
	const loadingOnly = args.animation && !args.title && !args.text && !args.buttons;
	let html = `<div class="msgbox${loadingOnly ? ' msgbox--loading' : ''}">`;

	if (args.title)
		html += makeDiv('mb-title', args.title);

	if (args.animation)
		html += makeDiv(
			'mb-icon mb-loading',
			'<div class="mb-spinner" role="status" aria-live="polite" aria-label="Carregando"></div>'
			+ '<div class="mb-loading-text">Carregando...</div>'
		);

	if (args.text)
		html += makeDiv('mb-text', args.text);

	if (args.buttons)
		html += makeButtons('button mtl', args.buttons);

	html += '</div>';

	return html;

};

const makeDiv = function(cls, html)
{
	return `<div class="${cls}">${html}</div>`;
};

const makeButtons = function(cls, buttons)
{
	return buttons.map(button => `<button class="${cls} ${button.cls}">${button.label}</button>`).join('\n');
};

const msgbox = function(args)		// { title: '', text: '', buttons: [ { label: '', cls: '' }, ... ], animation: true, timeout: 1000, callback: function }
{

	let dlg = dialog.create(makeHtml(args), args.callback, /Enter|Escape/);

	if (args.timeout)
	{
		setTimeout(() => dlg.destroy(), args.timeout);
	}

	return {
		destroy: () => dlg.destroy()
	};

};

const notify = function(text, title)
{
	let mb = msgbox({ title: title, text: text, buttons: [{ label: 'Continuar', cls: 'bn_Enter' }], callback: () => mb.destroy() });
};

const ask = function(text, title, callback)
{
	let mb = msgbox({ title: title, text: text, buttons: [{ label: 'Não', cls: 'bn_N' }, { label: 'Sim', cls: 'bn_Y' }], callback: (key) => { mb.destroy(); callback(key); }});
};

export { msgbox as default, notify, ask };

